import { Avatar } from '@mui/material';
import { ControlledAutocomplete } from 'Components';
import { AccordionArrowPurple } from 'Images';
import { ICriteriaStyle } from '..';
import {
  findResourceIdFromOptions,
  getSupplierResource,
  longestResourceOption,
  transformResourcesToStringArray,
} from 'Utils/suppliersResources';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { useSupplierContext } from 'Hooks/useSupplierContext';

export const MainCategory = ({
  autoCompleteSx,
  autoCompletePaperSx,
}: ICriteriaStyle) => {
  const { resources, filters, resetFiltersOnSpecialtyChange } =
    useSupplierContext();

  const isDesktop = useIsDesktop();

  const optionValue = getSupplierResource(resources.OCCUP, filters.specialty);
  const options: string[] = transformResourcesToStringArray(resources.OCCUP);

  return (
    <ControlledAutocomplete
      label=''
      ariaLabeledBy={Dictionary[DICTIONARY.Suppliers].resultPage.profession}
      options={options}
      value={optionValue}
      setValue={(value: string) => {
        if (value.length === 0) return;
        const specialty = findResourceIdFromOptions(resources.OCCUP, value);
        resetFiltersOnSpecialtyChange(specialty);
      }}
      style={{
        ...autoCompleteSx,
        width: isDesktop ? undefined : '100%',
        '&&& .MuiOutlinedInput-input': {
          p: 0,
          width: `${optionValue?.replace(/\s/g, '').length}ch`,
          fontWeight: 600,
          cursor: 'pointer',
        },
      }}
      paperSx={{
        ...autoCompletePaperSx,
        width: `${longestResourceOption(options) + 2}ch`,
        boxShadow: 'none',
      }}
      noResultsText={Dictionary[DICTIONARY.Suppliers].resultPage.noResults}
      endAdornment={
        isDesktop ? (
          <Avatar
            alt=''
            src={AccordionArrowPurple}
            sx={{ width: '30px', height: '30px' }}
          />
        ) : null
      }
      endAdornmentActiveTransformations='rotate(180deg)'
      disableClearIcon
      resultLimit={options.length}
    />
  );
};
